const autoNgTemplateLoaderTemplate1 = require('./add-sales-rep.template.html');

'use strict';

(function () {
    angular
        .module('app.addSalesRep', [])
        .config(addSalesRepConfig);

    addSalesRepConfig.$inject = ['$routeProvider'];

    function addSalesRepConfig($routeProvider) {
        $routeProvider
            .when('/add-sales-rep', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'AddSalesRepController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                }
            })
    }
})();
